import { render, staticRenderFns } from "./visitor.vue?vue&type=template&id=2439d2f5&scoped=true&"
import script from "./visitor.vue?vue&type=script&lang=js&"
export * from "./visitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2439d2f5",
  null
  
)

export default component.exports